<!--
 * @Author: zhangwk
 * @Date: 2022-09-07 8:56:28
 * @LastEditors: zhangwk
 * @LastEditTime: 2022-09-07 8:56:28
 * @describe: swiper组件
-->
<template>
    <div class="bigHouseStys zhjcStyle">
        <div class="swiper-container gallery-top">
            <div class="swiper-wrapper swiperWrapperTop">
                <!-- <div class="swiper-slide" v-for="item in swiperList">
                    <template v-if="item.flag == 20 ">
                        <video :poster="imgPoster" :src="item.imgUrl" controls="controls">your browser does not support
                            the video tag</video>
                    </template>
                    <img :src="item.imgUrl" alt="" v-else>
                </div> -->
                <div class="swiper-slide" v-for="item in swiperList">
                    <template v-if="item.includes('.mp4')">
                        <video :poster="image" :src="item" controls="controls">your browser does not support
                            the video tag</video>
                    </template>
                    <img :src="item" alt="" v-else>
                </div>
            </div>
            <div class="swiper-button-next swiper-button-white el-icon-arrow-right"></div>
            <div class="swiper-button-prev swiper-button-white el-icon-arrow-left"></div>
        </div>
        <div class="gallery-thumbs-box">
            <div class="swiper-container gallery-thumbs swiper-container-bottom">
                <div class="swiper-wrapper swiperWrapperBot">
                    <!-- <div class="swiper-slide" v-for="item in swiperList" :class="item.flag== 20 ? 'swiperVideo' : '' ">
                        <template v-if="item.flag== 20 ">
                            <img :src="imgPoster" alt="">
                            <i class="el-icon-video-play pngvideo"></i>
                        </template>
                        <img :src="item.imgUrl" alt="" v-else>
                    </div> -->
                    <div class="swiper-slide" v-for="item in swiperList"
                        :class="item.includes('.mp4') ? 'swiperVideo' : '' ">
                        <template v-if="item.includes('.mp4')">
                            <img :src="image" alt="">
                            <i class="el-icon-video-play pngvideo"></i>
                        </template>
                        <img :src="item" alt="" v-else>
                    </div>
                </div>
                <!-- <div class="swiper-button-next swiper-button-white el-icon-arrow-right" ></div>
				<div class="swiper-button-prev swiper-button-white el-icon-arrow-left"  ></div> -->
            </div>
        </div>

    </div>
</template>
<script>

import Swiper from '@/utils/swiper.min.js'
export default {
    name: "ShopVewDetail",
    props: ["imgList", "image"],
    data() {
        return {
            swiperList: [],
            imgPoster: "",

        };
    },

    mounted() {
        this.swiperList = this.imgList;
        console.log(this.swiperList);
        // if (this.swiperList && this.swiperList.length > 0) {
        //     this.imgPoster = this.swiperList[0];
        // }
        // var arr = this.swiperList.filter(item => item.flag != 20); //不等于20 代表不是视频
        // if (arr && arr.length > 0) {
        //     this.imgPoster = arr[0].imgUrl;
        // }

        //imgPoster
        this.$nextTick(() => {
            this.swiperFun();
        })
    },

    methods: {
        swiperc() {
            var that = this;
            var swiper = new Swiper(".mySwiper", {
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                on: {
                    click: function () {
                        if (this.clickedIndex != undefined) {
                            that.swiperBigShow = true;
                        }
                    }
                }
            })

        },
        swiperFun() {
            var that = this;
            var galleryThumbs = new Swiper(".gallery-thumbs", {
                spaceBetween: 10,
                slidesPerView: "auto",
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true //修改swiper的父元素时，自动初始化swiper
            });
            var galleryTop = new Swiper(".gallery-top", {
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                thumbs: {
                    swiper: galleryThumbs
                },
                on: {
                    click: function () {
                        if (this.clickedIndex != undefined) {
                            //alert(this.clickedSlide.firstChild.currentSrc)
                            that.swiperBigShow = true;
                            that.srcImg = this.clickedSlide.firstChild.currentSrc;
                        }

                    }
                }
            });

        }
    },
};
</script>
  
<style lang="scss" scoped>
@import './swiper.min.css';

.gallery-thumbs-box {
    display: flex;
    justify-content: center;
}

.zhjcStyle .gallery-top {
    height: 440px;
    width: 100%;
    // margin-top: 20px;
}

.zhjcStyle .swiper-container {
    margin: 0 !important;
    overflow: inherit !important;
}

.zhjcStyle .swiper-container-bottom {
    overflow: hidden !important;
}

.zhjcStyle .gallery-top .swiper-slide {
    width: 100%;
}

.zhjcStyle .gallery-top img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
}

.zhjcStyle .gallery-thumbs {
    height: 20%;
    width: 90%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px 0;
}

.zhjcStyle .gallery-thumbs .swiper-slide-thumb-active {
    border: 2px solid #018388;
    opacity: 1 !important;
}

.zhjcStyle .gallery-thumbs .swiper-slide {
    width: 31.5%;
    height: 100px;
}

.zhjcStyle .gallery-thumbs .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    margin-right: 10px;
}

.zhjcStyle .swiper-button-next {
    right: 0;
}

.zhjcStyle .swiper-button-prev {
    left: 0;
}

.zhjcStyle .swiper-button-next,
.zhjcStyle .swiper-button-prev {
    background-image: none;
    font-size: 30px;
    top: inherit;
    ;
    bottom: -84px;
    // color: #A5A5A5;
}

.zhjcStyle .gallery-thumbs .swiper-slide video {}

.swiperVideo {
    position: relative;
}

.pngvideo {
    position: absolute;
    color: #666;
    left: 50%;
    top: 50%;
    font-size: 30px;
    margin-top: -15px;
    margin-left: -15px;
}
</style>
  